@if (src) {
    <div class="circle image-wrapper" [style.width.px]="size" [style.height.px]="size">
        <img [ngSrc]="src" [alt]="alt" [width]="size" [height]="size"/>
    </div>
} @else {
    <div class="circle" [attr.data-letters]="getAvatarText()" [style.width.px]="size" [style.height.px]="size"></div>
}
